import KendoTreeList from './KendoTreeList'
import KendoTreeListInstaller from './kendo-treelist-installer'

export { KendoTreeList, KendoTreeList as TreeList, KendoTreeListInstaller, KendoTreeListInstaller as TreeListInstaller }


// WEBPACK FOOTER //
// ./packages/kendo-treelist-vue-wrapper/src/index.js